import * as angular from "angular";

interface FileInputScope extends angular.IScope {
	onFile(args: { file?: File }): void;
}

export default angular.module("vesl.extensions.json-schema.file-input", [])
	.directive("jsonSchemaFileInput", () => ({
		restrict: "A",
		scope: { onFile: "&jsonSchemaFileInput" },
		link: (scope: FileInputScope, element: angular.IAugmentedJQuery) => {
			const changed = (event: Event) => {
				const target = event.target;

				if(target instanceof HTMLInputElement) {
					const file = target.files?.[0];
					target.value = "";
					scope.$applyAsync(() => scope.onFile({ file }));
				}
			};

			element.on("change", changed);
			scope.$on("$destroy", () => element.off("change", changed));
		}
	}))
	.name;
